
import ReactDOM from "react-dom";
import React from "react";
import {Provider} from "react-redux";
import store from "../../products/product-page/data-services/store";
import VideoGallery from "./video-gallery";


/**
 * entry point
 */
export const init = () => {
    const $videoGalleryApp = document.getElementById('video-gallery-app');
    if ($videoGalleryApp)
    {
        ReactDOM.render(
            <React.StrictMode>
                <Provider store={ store }>
                    <VideoGallery videoGallery={[]} scrollMarginTop={-150}/>
                </Provider>
            </React.StrictMode>,
            $videoGalleryApp
        );
    }
};

/**
 * entry point
 */
document.addEventListener('DOMContentLoaded', () => {
    init();
});